import { type ReactNode } from 'react';

export type ChipVariant =
  /* Campaign */
  | 'live' | 'scheduled' | 'paused' | 'completed' | 'draft' | 'error' | 'archived'
  /* Domain */
  | 'verified' | 'warming' | 'pending' | 'failed' | 'primary-domain'
  /* JT sync */
  | 'success' | 'inprogress' | 'partial' | 'idle'
  /* Inbox */
  | 'unread' | 'open' | 'meeting' | 'awaiting' | 'unsubscribed' | 'negative' | 'snoozed' | 'hasnote';

interface ChipProps {
  variant: ChipVariant;
  children: ReactNode;
}

export function Chip({ variant, children }: ChipProps) {
  return (
    <span className={`chip chip-${variant}`}>
      {children}
    </span>
  );
}

/* Convenience map from display label → variant, used by the component library page */
export const CHIP_CATALOG: { label: string; variant: ChipVariant; group: string }[] = [
  { group: 'Campaign',   label: 'Live',            variant: 'live' },
  { group: 'Campaign',   label: 'Scheduled',       variant: 'scheduled' },
  { group: 'Campaign',   label: 'Paused',          variant: 'paused' },
  { group: 'Campaign',   label: 'Completed',       variant: 'completed' },
  { group: 'Campaign',   label: 'Draft',           variant: 'draft' },
  { group: 'Campaign',   label: 'Error',           variant: 'error' },
  { group: 'Campaign',   label: 'Archived',        variant: 'archived' },
  { group: 'Domain',     label: 'Verified',        variant: 'verified' },
  { group: 'Domain',     label: 'Warming',         variant: 'warming' },
  { group: 'Domain',     label: 'Pending DNS',     variant: 'pending' },
  { group: 'Domain',     label: 'Failed',          variant: 'failed' },
  { group: 'Domain',     label: 'Primary',         variant: 'primary-domain' },
  { group: 'JT Sync',   label: 'Success',         variant: 'success' },
  { group: 'JT Sync',   label: 'In Progress',     variant: 'inprogress' },
  { group: 'JT Sync',   label: 'Partial',         variant: 'partial' },
  { group: 'JT Sync',   label: 'Idle',            variant: 'idle' },
  { group: 'Inbox',      label: 'Unread',          variant: 'unread' },
  { group: 'Inbox',      label: 'Open to chat',    variant: 'open' },
  { group: 'Inbox',      label: 'Meeting booked',  variant: 'meeting' },
  { group: 'Inbox',      label: 'Awaiting reply',  variant: 'awaiting' },
  { group: 'Inbox',      label: 'Unsubscribed',    variant: 'unsubscribed' },
  { group: 'Inbox',      label: 'Negative',        variant: 'negative' },
  { group: 'Inbox',      label: 'Snoozed',         variant: 'snoozed' },
  { group: 'Inbox',      label: 'Has note',        variant: 'hasnote' },
];
